import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CardStepBodyComponent,
  DesktopBlSidebarComponent,
  DesktopHtsSidebarComponent,
  DesktopShipmentDetailsBlComponent,
  DesktopShipmentDetailsComponent,
  DesktopShipmentDetailsFormalComponent,
  DesktopShipmentDetailsHtsComponent,
  DesktopShipmentDetailsInformalComponent,
  DesktopShipmentDetailsTypeComponent,
  DesktopShipmentTypeSidebarComponent,
  DesktopSummaryCardComponent,
  DesktopSummaryCbpLogComponent,
  DesktopSummaryHtsBodyComponent,
  DesktopSummaryHtsComponent,
  DesktopSummaryReceivingPartyComponent,
  DesktopSummaryShipmentDetailsComponent,
  DesktopSummaryShippingPartyComponent,
  DesktopSummarySuccessHeaderComponent,
  DesktopSummaryUploadIsfDocumentsComponent,
  EntityUnifyCardComponent,
  EntityUnifyDefaultComponent,
  EntityUnifyDefaultDesktopComponent,
  EntityUnifyUpdateComponent,
  HtsMFComponent,
  IsfActionsComponent,
  IsfAttachDocumentsComponent,
  IsfBatchItemsComponent,
  IsfBatchReviewSidebarComponent,
  IsfBatchSidebarComponent,
  IsfBondDetailsComponent,
  IsfCardNoticeComponent,
  IsfDataCardComponent,
  IsfDetailComponent,
  IsfDocsStripComponent,
  IsfDocumentsBoxComponent,
  IsfDocumentUploadComponent,
  IsfEntityDetailsComponent,
  IsfHtsControlComponent,
  IsfHtsDetailsComponent,
  IsfInformalEstimationDetailsComponent,
  IsfItemsSearchComponent,
  IsfListAdminComponent,
  IsfListComponent,
  IsfOcrQuickFixBlDetailsComponent,
  IsfOcrQuickFixBuyerDetailsComponent,
  IsfOcrQuickFixConsigneeDetailsComponent,
  IsfOcrQuickFixConsolidatorDetailsComponent,
  IsfOcrQuickFixCslDetailsComponent,
  IsfOcrQuickFixHeaderComponent,
  IsfOcrQuickFixInterHtsCodeDetailsComponent,
  IsfOcrQuickFixManufacturerDetailsComponent,
  IsfOcrQuickFixShipToDetailsComponent,
  IsfOcrQuickFixSidebarComponent,
  IsfOcrQuickFixSupplierDetailsComponent,
  IsfShipmentDetailsComponent,
  IsfStatusComponent,
  IsfSummaryDetailsComponent,
} from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { TranslateModule } from '@ngx-translate/core';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { DocumentModule } from '@shared/document/document.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { RouterModule } from '@angular/router';
import { CbpMessagesModule } from '@shared/cbp-messages/cbp-messages.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfoModule } from '@shared/info/info.module';
import { AddressModule } from '@shared/address/address.module';
import { NgxMaskModule } from 'ngx-mask';
import { BillSharedModule } from '@shared/bill-shared/bill-shared.module';
import { EsMutualModule } from '@shared/es-mutual/es-mutual.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PaginationModule } from '@shared/pagination/pagination.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { NgSelectModule } from '@ng-select/ng-select';
import { IsfDetailsValidationService, IsfPossibleEntitiesService, IsfStateService } from './services';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { EntityMutualModule } from '@shared/entity-mutual/entity-mutual.module';
import { MissingFieldsModule } from '@shared/missing-fields/missing-fields.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { BatchImportMutualModule } from '@shared/batch-import-mutual/batch-import-mutual.module';
import { EntityModule } from '@shared/entity/entity.module';
import { MarineInsuranceSharedModule } from '@shared/marine-insurance-shared';
import { LayoutsModule } from '@shared/layouts/layouts.module';
import { CustomToastModule } from '@shared/custom-toast/custom-toast.module';
import { BinaSharedModule } from '@shared/bina-shared/bina-shared.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { IdentifierUpdateModule } from '@shared/identifier-update/identifier-update.module';
import { PoaRequiredModalModule } from '@shared/poa-required-modal/poa-required-modal.module';

@NgModule({
  declarations: [
    IsfActionsComponent,
    IsfAttachDocumentsComponent,
    IsfDocumentUploadComponent,
    IsfDocumentsBoxComponent,
    IsfCardNoticeComponent,
    IsfBondDetailsComponent,
    IsfInformalEstimationDetailsComponent,
    IsfShipmentDetailsComponent,
    IsfEntityDetailsComponent,
    IsfHtsDetailsComponent,
    IsfSummaryDetailsComponent,
    IsfDataCardComponent,
    IsfListComponent,
    IsfDetailComponent,
    IsfItemsSearchComponent,
    IsfListAdminComponent,
    IsfStatusComponent,

    DesktopSummaryReceivingPartyComponent,
    DesktopSummaryCardComponent,
    DesktopSummaryShippingPartyComponent,
    DesktopSummaryHtsComponent,
    DesktopSummaryHtsBodyComponent,
    DesktopSummaryShipmentDetailsComponent,
    DesktopSummarySuccessHeaderComponent,
    DesktopSummaryCbpLogComponent,
    DesktopSummaryUploadIsfDocumentsComponent,
    IsfBatchSidebarComponent,
    IsfBatchItemsComponent,
    IsfBatchReviewSidebarComponent,

    EntityUnifyDefaultComponent,
    EntityUnifyDefaultDesktopComponent,
    EntityUnifyCardComponent,
    EntityUnifyUpdateComponent,
    DesktopShipmentDetailsComponent,
    DesktopShipmentDetailsTypeComponent,
    DesktopShipmentDetailsInformalComponent,
    DesktopShipmentDetailsFormalComponent,
    DesktopShipmentDetailsBlComponent,
    DesktopShipmentDetailsHtsComponent,
    HtsMFComponent,
    IsfHtsControlComponent,
    DesktopHtsSidebarComponent,
    DesktopBlSidebarComponent,
    DesktopShipmentTypeSidebarComponent,
    CardStepBodyComponent,
    IsfDocsStripComponent,
    IsfOcrQuickFixHeaderComponent,
    IsfOcrQuickFixSidebarComponent,
    IsfOcrQuickFixConsigneeDetailsComponent,
    IsfOcrQuickFixBuyerDetailsComponent,
    IsfOcrQuickFixShipToDetailsComponent,
    IsfOcrQuickFixSupplierDetailsComponent,
    IsfOcrQuickFixConsolidatorDetailsComponent,
    IsfOcrQuickFixCslDetailsComponent,
    IsfOcrQuickFixManufacturerDetailsComponent,
    IsfOcrQuickFixInterHtsCodeDetailsComponent,
    IsfOcrQuickFixBlDetailsComponent,
  ],
  imports: [
    BinaSharedModule,
    CommonModule,
    FormWrapperModule,
    TranslateModule,
    CustomModalModule,
    CustomToastModule,
    DocumentModule,
    PipesSharedModule,
    RouterModule,
    CbpMessagesModule,
    InfoModule,
    AddressModule,
    NgxMaskModule,
    BillSharedModule,
    EsMutualModule,
    FlexLayoutModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    PaginationModule,
    MutualModule,
    MarineInsuranceSharedModule,
    NgxPaginationModule,
    DirectivesModule,
    NgSelectModule,
    NzToolTipModule,
    EntityMutualModule,
    MissingFieldsModule,
    NzPopoverModule,
    BatchImportMutualModule,
    IdentifierUpdateModule,
    EntityModule,
    LayoutsModule,
    PoaRequiredModalModule,
  ],
  exports: [
    IsfActionsComponent,
    IsfAttachDocumentsComponent,
    IsfDocumentUploadComponent,
    IsfDocumentsBoxComponent,
    IsfCardNoticeComponent,
    IsfBondDetailsComponent,
    IsfInformalEstimationDetailsComponent,
    IsfShipmentDetailsComponent,
    IsfEntityDetailsComponent,
    IsfHtsDetailsComponent,
    IsfSummaryDetailsComponent,
    IsfDataCardComponent,
    IsfListComponent,
    IsfListAdminComponent,
    IsfStatusComponent,

    DesktopSummaryReceivingPartyComponent,
    DesktopSummaryCardComponent,
    DesktopSummaryShippingPartyComponent,
    DesktopSummaryHtsComponent,
    DesktopSummaryHtsBodyComponent,
    DesktopSummaryShipmentDetailsComponent,
    DesktopSummarySuccessHeaderComponent,
    DesktopSummaryCbpLogComponent,
    DesktopSummaryUploadIsfDocumentsComponent,
    IsfBatchSidebarComponent,
    IsfBatchItemsComponent,
    IsfBatchReviewSidebarComponent,

    EntityUnifyDefaultComponent,
    EntityUnifyDefaultDesktopComponent,
    EntityUnifyCardComponent,
    EntityUnifyUpdateComponent,
    DesktopShipmentDetailsComponent,
    DesktopShipmentDetailsTypeComponent,
    DesktopShipmentDetailsInformalComponent,
    DesktopShipmentDetailsFormalComponent,
    DesktopShipmentDetailsBlComponent,
    DesktopShipmentDetailsHtsComponent,
    HtsMFComponent,
    IsfHtsControlComponent,
    DesktopHtsSidebarComponent,
    DesktopBlSidebarComponent,
    DesktopShipmentTypeSidebarComponent,
    CardStepBodyComponent,
    IsfDocsStripComponent,
    IsfOcrQuickFixHeaderComponent,
    IsfOcrQuickFixSidebarComponent,
    IsfOcrQuickFixConsigneeDetailsComponent,
    IsfOcrQuickFixBuyerDetailsComponent,
    IsfOcrQuickFixShipToDetailsComponent,
    IsfOcrQuickFixSupplierDetailsComponent,
    IsfOcrQuickFixConsolidatorDetailsComponent,
    IsfOcrQuickFixCslDetailsComponent,
    IsfOcrQuickFixManufacturerDetailsComponent,
    IsfOcrQuickFixInterHtsCodeDetailsComponent,
    IsfOcrQuickFixBlDetailsComponent,
  ],
  providers: [IsfStateService, IsfPossibleEntitiesService, IsfDetailsValidationService],
})
export class IsfMutualModule {}
